import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 32, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function Kinetic({ lines, className = "", delay = 0.3 }) {
  return (
    <span className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.2, delay: delay + i * 0.16, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function ZoomImage({ src, alt, className = "", duration = 2.6, delay = 0 }) {
  return (
    <motion.img
      src={src}
      alt={alt}
      className={className}
      initial={{ scale: 1.14 }}
      animate={{ scale: 1 }}
      transition={{ duration, delay, ease: EASE }}
      loading="eager"
    />
  );
}

export function Label({ children, dark = false, className = "" }) {
  return (
    <span
      className={`label inline-flex items-center gap-4 ${
        dark ? "text-gold" : "text-gold"
      } ${className}`}
    >
      <span className="gold-rule" />
      {children}
    </span>
  );
}
